import axios from "axios";
import TrackingLinks from "./TrackingLinks";
import { joinURLs } from "../../utils/urlUtil";
import { getHeadersConfig } from "../../utils/config";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import ModalHeader from "../modal/ModalHeader";
import ModalFooter from "../modal/ModalFooter";
let getClinkURLsAbortController = new AbortController();

const getClinkURLs = async (clinkId:string, setClinkURLsIsLoading:any, setShowClinkData:any) => {
  const url = joinURLs("admin/clinks", process.env.REACT_APP_JUPITER_API_BASE_URL);

  const params = {
    "clinkID": clinkId,
    "method": "getClinkURLs",
    "target": "json"
  };
  setClinkURLsIsLoading(true);
  try {

    const response:any = await axios.get(url, {...getHeadersConfig(), params, signal: getClinkURLsAbortController.signal });
    if (response.data) {
      setShowClinkData({
        ...response.data,
        clinkID: clinkId
      })
    } else {
      setShowClinkData(null);
    }
  } catch (error:any) {
    // handle error
    console.log('error', error);
    setShowClinkData(null);
  }
  setClinkURLsIsLoading(false);
}

function ModalTrackingLinks(props:any) {
  const { showTrackingLinks, setShowTrackingLinks, clinkid, previewLink, app } = props;
  const [clinkURLsIsLoading, setClinkURLsIsLoading] = useState(false);
  const [showClinkData, setShowClinkData] = useState(null);

  useEffect(() => {
    if (showTrackingLinks) {
      getClinkURLs(clinkid, setClinkURLsIsLoading, setShowClinkData);
    }
  }, [clinkid, showTrackingLinks]);

  return (
    <Modal
      size="lg"
      show={showTrackingLinks} onHide={() => setShowTrackingLinks(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
    <ModalHeader title="cLink Tracking Links" useIcon={true} icon={app.icon ? app.icon : null} />
      <Modal.Body style={{ maxHeight: "calc(100vh - 280px)", overflowY: "auto" }}>
        <TrackingLinks
          loadingClinkURLs={clinkURLsIsLoading}
          showClinkData={showClinkData}
          previewLink={previewLink}
        />
      </Modal.Body>
      <ModalFooter close={() => setShowTrackingLinks(false)}/>
    </Modal>
  );
}
export default ModalTrackingLinks;
